import { TagOption } from './TagOption';
import styles from './Tag.module.scss';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import TagImage from './TagImage';

interface TagProps<T> {
    tag: TagOption<T>;
    disabled?: boolean;
    className?: string;
    onRemove?: () => void;
}

export const Tag = <T,>(props: TagProps<T>) => {
    const isRemovable = props.tag.isRemovable !== false;

    return (
        <div className={clsx(styles.container, props.className)}>
            {props.tag.image && (
                <div className={styles.imageContainer}>
                    <TagImage src={props.tag.image} />
                </div>
            )}
            {props.tag.image === undefined && props.tag.icon && (
                <div className={styles.iconContainer}>
                    <FontAwesomeIcon icon={props.tag.icon} />
                </div>
            )}
            <div className={styles.nameContainer}>
                <span className={styles.name}>{props.tag.name}</span>
            </div>
            {isRemovable && !props.disabled && (
                <div
                    className={styles.removeContainer}
                    onClick={props.onRemove}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </div>
            )}
        </div>
    );
};

export default Tag;
